import { o2oApi } from 'yxt-biz-pc/packages/api';

// 学员端项目集多班次项目子项目列表
export const getEnrollProjectChildList = (id) => {
  return o2oApi.get(`projectIntegrate/stu/projectChildList/${id}?simple=1`);
};
